import classNames from "classnames";
import * as React from "react";

import styles from "./DataTable.module.css";

interface DataTableActionsProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Horizontal action-button row slot for `DataTable.Root`. Hosts the filter
 * button and any future controls (column visibility, density, export).
 * Children lay out in a flex row with consistent gap and wrap onto a new
 * line on narrow viewports; consumers wrap it in their own div if they
 * need additional alignment.
 *
 * @example
 * ```tsx
 * <DataTable.Root>
 *   <DataTable.Actions>
 *     <DataTable.Filters filterDefinitions={fields} />
 *   </DataTable.Actions>
 *   <DataTable.Table {...tableState.table} ... />
 * </DataTable.Root>
 * ```
 */
export function DataTableActions({
  children,
  className,
}: DataTableActionsProps) {
  return (
    <div className={classNames(styles.actions, className)}>{children}</div>
  );
}
